import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import React from 'react';
import './steps.styl';

const Bubble = ({ s, step, currentStep }) => {
  if (s + 1 < currentStep) {
    return (
      <div className="step" key={s}>
        <CheckCircle className="check" />
        <p className="complete__step__text">{step}</p>
      </div>
    );
  } else if (s + 1 === currentStep) {
    return (
      <div className="step" key={s}>
        <div className="bubble">
          <h4 className="bubble_text">{s + 1}</h4>
        </div>
        <p className="text complete__step__text">{step}</p>
      </div>
    );
  }
  return (
    <div className="step" key={s}>
      <div className="bubble">
        <h4 className="opaque bubble__text">{s + 1}</h4>
      </div>
      <p className="text opaque complete__step__text">{step}</p>
    </div>
  );
};

export default ({ steps = [], currentStep = 0, stepsMessage }) => (
  <div className="wrapper">
    {stepsMessage && <div className="message">{stepsMessage}</div>}
    <div className="steps_and_ruler_container">
      <div className="step__container">
        {steps.map((step, s) => (
          <Bubble {...{ currentStep, step, s }} key={s} />
        ))}
      </div>
      <hr className="ruler" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/steps/index.js